import { render, staticRenderFns } from "./my-document.vue?vue&type=template&id=0ac9c72e&scoped=true&"
import script from "./js/my-document.js?vue&type=script&lang=js&"
export * from "./js/my-document.js?vue&type=script&lang=js&"
import style0 from "./my-document.vue?vue&type=style&index=0&id=0ac9c72e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac9c72e",
  null
  
)

export default component.exports